import { render, staticRenderFns } from "./SearchBody.vue?vue&type=template&id=732cc875"
import script from "./SearchBody.vue?vue&type=script&lang=ts"
export * from "./SearchBody.vue?vue&type=script&lang=ts"
import style0 from "./SearchBody.module.scss?vue&type=style&index=0&prod&lang=scss&module=styles&external"




function injectStyles (context) {
  
  this["styles"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports